import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import { setErrorAction, setNetworkErrorAction, setWppErrorAction } from './actions';

const INIT_STATE = {
  networkError: false,
  error: false,
  wppError: false
};

export default createReducer(INIT_STATE)
  .handleAction(purge, () => INIT_STATE)
  .handleAction(setNetworkErrorAction, (state, action) => {
    return {
      ...state,
      networkError: true
    }
  })
  .handleAction(setErrorAction, (state, action) => {
    return {
      ...state,
      error: action.payload
    }
  })
  .handleAction(setWppErrorAction, (state, action) => {
    return {
      ...state,
      wppError: action.payload
    }
  });
